<script lang="ts">
    import {getDateFormatter} from 'src/core';
    import type {MessageSendingPost} from 'src/typings';
    import {Kind} from 'shared/constants';
    import {exists} from 'shared/utils/custom-utils';
    import {pipe} from 'core/utils';
    import KpMessageSendingLabeledInfo from './KpMessageSendingLabeledInfo.svelte';
    import Label from 'shared/components/kp-label/Label.svelte';

    export let sending: MessageSendingPost;

    const dateFormatter = getDateFormatter();
</script>

<KpMessageSendingLabeledInfo title="Adresa:">
    {sending.address}
</KpMessageSendingLabeledInfo>

{#if exists(sending.fulltextId)}
    <strong><a href="/files/{sending.fulltextId}" target="_blank">Stáhnout zprávu</a></strong>
{/if}

{#if exists(sending.printingEvent) && exists(sending.printingEvent?.initiatorUser)}
    Vitisknuto <strong>{pipe(sending.printingEvent.createDate, dateFormatter('d.M.yyyy HH:mm'))}</strong>
    uživatelem <strong><Label explicitKind={Kind.KIND_USER} labeled={sending.printingEvent.initiatorUser}/></strong>
{/if}